var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 118,
    viewBox: "0 0 160 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.527539,
    y: 89.8968,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-86.7504 0.527539 89.8968)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.19172,
    y: 74.3417,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-75 4.19172 74.3417)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.34695,
    y: 55.7213,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-60 9.34695 55.7213)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3336,
    y: 38.7509,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-45 19.3336 38.7509)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1752,
    y: 25.1361,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-30 32.1752 25.1361)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.6959,
    y: 16.5434,
    width: 48.9061,
    height: 72.5459,
    rx: 5.5,
    transform: "rotate(-15 49.6959 16.5434)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 11.0367,
    width: 49,
    height: 72,
    rx: 5.5,
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.6523,
    y: 12.9223,
    width: 49,
    height: 72,
    rx: 5.5,
    transform: "rotate(15 85.6523 12.9223)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 103.782,
    y: 17.6098,
    width: 49,
    height: 72,
    rx: 5.5,
    transform: "rotate(30 103.782 17.6098)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 120.132,
    y: 26.2568,
    width: 49,
    height: 72,
    rx: 5.5,
    transform: "rotate(45 120.132 26.2568)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 133.927,
    y: 38.8191,
    width: 49,
    height: 72,
    rx: 5.5,
    transform: "rotate(60 133.927 38.8191)",
    fill: "#FFECEC",
    stroke: "#F24645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/CARDS.9132e3e4100224db425c90fa10c0e818.svg";
export { ForwardRef as ReactComponent };